<template>
    <div>
        <h3 class="title">商家登录</h3>
        <div class="switch">
            <!-- <span :class="form.loginType === 'normal' && 'active' " @click="form.loginType = 'normal'">账号密码登录</span> -->
            <span :class="form.loginType === '' && 'active' " >账号密码登录</span>
            <!--<i style="margin: 0 20px">|</i>-->
            <!--<span :class="form.loginType === 'mobile' && 'active' " @click="form.loginType = 'mobile'">手机验证码登录</span>-->
        </div>
        <el-form :model="form" ref="form" label-position="left" label-width="0px">
            <template v-if="form.loginType === 'mobile' || form.loginType == 'subAccount'">
                <el-form-item prop="account">
                    <el-input type="text" v-model="form.loginKey" auto-complete="off" placeholder="请输入登录账号">
                        <i slot="prefix" class="iconfont iconyonghu"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                    <el-input type="password"
                              v-model="form.password"
                              auto-complete="off"
                              placeholder="请输入登录密码">
                        <i slot="prefix" class="iconfont iconmima"></i>
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                        v-model="form.smsCode"
                        type="test"
                        placeholder="请输入您的手机验证码"
                        style="width: 70%"
                    >
                        <i slot="prefix" class="iconfont iconT1"></i>
                    </el-input>
                    <el-button :loading="smsCodeBtnLoading" :disabled="sendCode!=='发送验证码'" class="sms-btn" @click="getCode">{{sendCode}}
                    </el-button>
                </el-form-item>
            </template>
            <template v-else>
                <el-form-item>
                    <el-input placeholder="请输入您的手机号码" v-model="form.loginKey">
                        <i slot="prefix" class="iconfont iconyonghu"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="form.password"
                        type="test"
                        placeholder="请输入您的手机验证码"
                        style="width: 70%"
                    >
                        <i slot="prefix" class="iconfont iconT1"></i>
                    </el-input>
                    <el-button :disabled="sendCode!=='发送验证码'" style="width: 30%" @click="getCode">{{sendCode}}
                    </el-button>
                </el-form-item>
            </template>
            <el-checkbox v-model="form.isSubAccount" class="remember">子账号登录</el-checkbox>
        </el-form>
        <div>
            <el-button type="primary" style="width: 100%;margin-top: 20px" :loading="loading" @click="submit">登录
            </el-button>
        <!--    <div class="bottom-text">-->
        <!--        <p>没有账号？<span class="font-blue gesture" @click="$router.push('/register')">注册</span></p>-->
        <!--        <p class="gesture" @click="$router.push('/reset')">忘记密码</p>-->
        <!--    </div>-->
        </div>
    </div>
</template>

<script>
    import { Login, GetUserInfo, postSmsCode, getStoreInfoApi } from '@/api'
    import { isPhone, isValidPassword } from '@/utils/is'

    export default {
        name: 'login',
        data() {
            return {
                loading: false,
                form: {
                    accessPortal: 'businessPC', // 登录平台
                    loginType: 'mobile', // 登录类型
                    loginKey: null, // 登录账号
                    password: null, // 密码或验证码
                    isSubAccount: false, // 是否子账号
                    mobilePhone: '', // 兼容接口无法识别 loginKey 字段问题
                    smsCode: '', // 短信验证码
                    portalId: 2,
                },
                sendCode: '发送验证码',
                smsCodeBtnLoading: false,
            }
        },
        watch: {
            // 'form.loginType'() {
            //     this.form.loginKey = null;
            //     this.form.password = null
            // }
			
			
        },
        methods: {
            // 登录
            async submit() {
                let {smsCode, loginKey, password} = this.form
                if (!smsCode || !loginKey || !password) {
                    this.$message({
                        message: '请填写完表单',
                        type: 'error'
                    });
                    return
                }

                if (!isValidPassword(password)) {
                    this.$message({
                        message: '您的密码过于简单，请到“智智小店”APP中修改',
                        type: 'error'
                    });
                    return
                }

                this.loading = true;
                try {
					if (this.form.isSubAccount) {
						this.form.loginType = 'subAccount'
					} else {
						this.form.loginType = 'mobile'
					}

                    this.form.mobilePhone = loginKey
					
                    const data = await Login(this.form);
                    this.$store.dispatch('setToken', data.data.accessToken);
                    const [info, store] = await Promise.all([GetUserInfo({ id: data.data.userId, isSubAccount: this.form.isSubAccount }), getStoreInfoApi()]);
                    this.$store.dispatch('setUser', {...info.data, ...store.data});
                    this.$message({
                        message: '登录成功',
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.$router.replace('/')
                    }, 1000);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                }
            },
            // 发送验证码
            async getCode() {

                if (!isPhone(this.form.loginKey)) {
                    return this.$message({
                        message: '请输入有效手机号',
                        type: 'error'
                    });
                }

                try {
                    this.smsCodeBtnLoading = true
                    let res = await postSmsCode({
                        to: this.form.loginKey,
                        vcodeType: 'login-portal-vcode',
                        portalId: this.form.portalId,
                    })
                    this.smsCodeBtnLoading = false

                    if (res && res.code === 0) {
                        this.sendCode = 60;
                        let time = setInterval(() => {
                            this.sendCode--;
                            if (this.sendCode === 0) {
                                clearInterval(time);
                                this.sendCode = '发送验证码'
                            }
                        }, 1000)
                    }

                } catch (err) {
                    this.smsCodeBtnLoading = false
                }

            },
        },
    }
</script>

<style scoped lang="less">
    .switch {
        font-size: 18px;
        text-align: center;
        margin: 0 auto 20px;
        color: rgba(255, 255, 255, 0.6);
        letter-spacing: 1px;
        span {
            cursor: pointer;
        }
    }

    .active {
        color: #fff;
    }

    .sms-btn {
        width: 30%;
        padding-left: 0;
        padding-right: 0;
    }

</style>
